import React, { useEffect, useState } from "react";
import { Link, redirect, useNavigate } from "react-router-dom";
import { Container, Navbar, Row, Nav, NavDropdown } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
const Menu = () => {
  const location = useLocation();
  const [menuOpenQuiniela, setMenuOpenQuiniela] = useState(false);
  const [menuOpenComercial, setMenuOpenComercial] = useState(false);
  const [menuOpenSeguro, setMenuOpenSeguro] = useState(false);
  const [expanded, setExpanded] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const navigate = useNavigate();

  const togleDropDownQuiniela = () => {
    const value = !menuOpenQuiniela
    setMenuOpenQuiniela(value);
  }
  const togleDropDownComercial = () => {
    const value = !menuOpenComercial
    setMenuOpenComercial(value);
  }
  const togleDropDownSeguro = () => {
    const value = !menuOpenSeguro
    setMenuOpenSeguro(value);
  }

  const togleExpand = () => {
    const value = !expanded
    setExpanded(value);
  }

  return (
    <>
      <Container style={{ backgroundColor: 'white', maxWidth: '100%',padding:'1.5%',paddingLeft:'3.5%',paddingRight:'3.6%' }}>
        <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Navbar expanded={expanded} onToggle={togleExpand} expand="lg" className="bg-body-tertiary bg-transparent" style={{ whiteSpace: 'nowrap' }}>
            <Navbar.Brand as={Link} to='https://cajapopular.gov.ar/' className="justify-content-start ps-3">
              <img
                src={require("../../img/Logo-Caja-Popular-de-Ahorros.jpg")}
                alt="Logo Caja Popular de Ahorros"
                style={{
                  height: "9.6vh",

                }} // Esta clase centrará el logo horizontalmente.
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="justify-content-end">
              <Nav>
                <Nav.Link as={Link} to="https://cajapopular.gov.ar/index.php/institucional/">Institucional</Nav.Link>
                <NavDropdown title={
                  <span>Juegos
                    {!isMobile ?
                      <KeyboardArrowDownIcon />
                      : null
                    }
                  </span>
                }
                  show={menuOpenQuiniela}
                  drop="down"
                  onMouseEnter={!isMobile ? () => setMenuOpenQuiniela(true) : undefined}
                  onMouseLeave={!isMobile ? () => setMenuOpenQuiniela(false) : undefined}
                  onClick={isMobile ? togleDropDownQuiniela : undefined}
                >
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="/BuscarTuqui">Tuqui 10</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="/BuscarExtracto">Quiniela</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/1249-2/#hip">Hipódromo</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/1249-2/#CasinoEscritorio">Casino</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title={
                  <span>Comercial
                    {!isMobile ?
                      <KeyboardArrowDownIcon />
                      : null
                    }</span>}
                  show={menuOpenComercial}
                  drop="down"
                  onMouseEnter={!isMobile ? () => setMenuOpenComercial(true) : undefined}
                  onMouseLeave={!isMobile ? () => setMenuOpenComercial(false) : undefined}
                  onClick={isMobile ? () => togleDropDownComercial() : () => window.location.href = "https://cajapopular.gov.ar/index.php/comercial/"}
                >
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/comercial/#h_47223965361732028666850">Caja de Ahorros</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/comercial/#h_65704317871732028860473">Impuestos y Servicios</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/comercial/#h_145676231101732029421590">Caja de Seguridad</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/comercial/#h_94094859291732029223773">Caja Premium</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/comercial/#h_728487685121732031243451">Cajeros Automáticos</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/comercial/#h_176428350131732031769942">Fiduciarios</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/3568-2/">CFI</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link as={Link} to="https://cajapopular.gov.ar/index.php/tarjeta/">Tarjeta</Nav.Link>
                <NavDropdown title={
                  <span>Seguro
                    {!isMobile ?
                      <KeyboardArrowDownIcon />
                      : null
                    }
                  </span>}
                  show={menuOpenSeguro}
                  drop="down"
                  onClick={isMobile ? () => togleDropDownSeguro() : () => window.location.href = "https://www.cajapopular.gov.ar/index.php/1358-2/"}
                  onMouseEnter={!isMobile ? () => setMenuOpenSeguro(true) : undefined}
                  onMouseLeave={!isMobile ? () => setMenuOpenSeguro(false) : undefined}
                >
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/automotor-2/">Automotor</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/caucion/">Caución</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/colectivo-de-vida/">Colectivo de Vida</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/clase-protegida/">Seguro Escolar</NavDropdown.Item>
                  <NavDropdown.Item as={Link} onClick={togleExpand} to="https://www.cajapopular.gov.ar/index.php/1358-2/">Otros Seguros</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link as={Link} to="https://cajapopular.gov.ar/index.php/art-3/">ART</Nav.Link>
                <Nav.Link as={Link} to="https://cajapopular.gov.ar/index.php/sucursales/">Sucursales</Nav.Link>
                <Nav.Link as={Link} to="https://cajapopular.gov.ar/index.php/fecpa/">FECPA</Nav.Link>
                <Nav.Link as={Link} to="https://cajapopular.gov.ar/index.php/3286-2/">Eco Caja</Nav.Link>
                <Nav.Link as={Link} to="https://cajapopular.gov.ar/index.php/2135-2/">Contacto</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Row>
      </Container>
      <Container style={{ maxWidth: '100%', position: 'relative' }}>
        <Row >
          {location.pathname.includes("BuscarTuqui") ?
            <img
              src={require("../../img/Slider web Tuqui.gif")}
              alt="Logo Caja Popular de Ahorros"
              style={{
                display: "block",
                margin: "0 auto",
                width: "100%",
                height: "80%",
                marginTop: "0%",
                marginBottom: "0%",
              }}
            />
            :
            <img
              src={require("../../img/slider-quiniela-horarios.png")}
              alt="Logo Caja Popular de Ahorros"
              style={{
                display: "block",
                margin: "0 auto",
                width: "100%",
                marginTop: "0%",
                marginBottom: "0%",
              }}
            />
          }
        </Row>
      </Container>
    </>
  );
};

export default Menu;
